/// <reference path="../../common/controllers/screencontrollerbase.ts" />
module App.HiLO.Controllers {

    export enum ExclusionList {
        none = 0,
        charges = 1,
        target = 2
    }

	export class SimpleFile{
        public name: string;
        public description: string;
        public isRequired:boolean = true;
        public hasUploaded: boolean = false;
		public isAdditional: boolean = false;
		public skipped: boolean = false;
    }
  

    'use strict';
    export abstract class HiLOControllerBase<T extends Hca.HiLO.ViewModel.IQuestionViewModelBase> extends App.Common.Controllers.ScreenControllerBase {

        public shortDateFormat = 'dd/MM/yyyy';
        public config = {
            datepickerOptions: {
                showWeeks: false,
                startingDay: 1,
                clearText: 'Clear',
                closeOnDateSelection: true,
                closeText: 'Done',
                currentText: 'Today',
                showButtonBar: true
            },
            datesaveOptions: {
                timezone: 'UTC'
            }
        };

        public extraDocument: SimpleFile = { name: 'Additional Documents', description: 'Supporting Document', hasUploaded: false, isAdditional: true, isRequired: false, skipped: false };
        public extraFileCounter = 0;

        public model: T;
        public refNumberService: App.HiLO.Services.ReferenceNumberService;
        public referenceDataService: App.HiLO.Services.ReferenceDataService;
        public currentSection: number;
        public uploadedFiles: string[];
        public enableContinue: boolean;
        public filesToUpload: SimpleFile[];

        public currentUpload: string;
        public isNotExcluded: boolean;
        public warningMessage: string;
        public ExclusionList = ExclusionList;
        public showAddtionalUpload: boolean;
        public today: Date;

        public predecessorOrgs: {name: string}[] = [];

        constructor(public $injector: angular.auto.IInjectorService) {
            super($injector);
            this.currentSection = 0;
            this.uploadedFiles = [];
            this.refNumberService = $injector.get<App.HiLO.Services.ReferenceNumberService>('app.hilo.services.referenceNumberService');
            this.referenceDataService = $injector.get<App.HiLO.Services.ReferenceDataService>('app.hilo.services.referenceDataService');
            this.today = new Date();
            this.showAddtionalUpload = false;
			this.referenceDataService.getData().then((response) => {
                this.predecessorOrgs = <{name: string}[]>response.data;
            });
        }

        public currentFormName: string = 'preReq';

        protected mainForm() {
            // return this.formHelper.mainForm();
            return this.formHelper.getFormController(this.currentFormName);
        }

        public setContinueState(value: boolean): void {
            this.enableContinue = value;
        }

        public requiredDocs(): number {
	        return _.filter(this.filesToUpload, ['isRequired', true]).length;
        }

        public requiredDocsUploaded() {
            return _.filter(this.filesToUpload, { 'hasUploaded': true, 'isRequired': true }).length === this.requiredDocs();
        }

        public docsUploaded(): boolean {
            return _.filter(this.filesToUpload, { 'hasUploaded': true }).length ===this.filesToUpload.length;
        }

        public setProviderSchemes(provider: ExclusionList) {

            switch (provider) {
                case ExclusionList.none:
                    this.isNotExcluded = true;
                    this.model.isNotExcluded = true;
                    this.setWarningMessage(ExclusionList.none);
                    this.setModelChange('isNotExcluded');
                    break;
                case ExclusionList.charges:
                    this.isNotExcluded = false;
                    this.model.isNotExcluded = false;
                    this.setModelChange('isNotExcluded');
                    this.setWarningMessage(provider);
                    break;
                case ExclusionList.target:
                    this.isNotExcluded = false;
                    this.model.isNotExcluded = false;

                    this.setModelChange('isNotExcluded');
                    this.setWarningMessage(provider);
                    break;
                default:
                    this.isNotExcluded = false;
                    this.model.isNotExcluded = false;

                    this.setModelChange('isNotExcluded');
                    this.setWarningMessage(provider);
                    break;
            }
        }

        private getMailLinkForEmail(email: string){
            return "<a href='mailto:" + email + "'>" + email + "</a>";
        }

        public setWarningMessage = (provider: ExclusionList) => {
            const warningBase = "Sorry we cannot help you.  Please contact ";
            switch (provider) {
                case ExclusionList.none:
                    this.warningMessage = '';

                    break;
                case ExclusionList.target:
                    this.warningMessage = warningBase
                        + this.getMailLinkForEmail(this.globalSettings.emails.postSalesAgentContactEmail);
                    break;
                case ExclusionList.charges:
                    this.warningMessage = warningBase
                        + this.getMailLinkForEmail(this.globalSettings.emails.chargesTeamEmail);
                    break;
                default:
                    this.warningMessage = "";
                    break;
            }
        }

        public questionList = [

        ];

        public setModelChange(ctrl) {
            // ToDo: why was this left in?
            // for (var property in this.model) {
            //     console.log(this.model[property]);
            // }

            var parent = _.find(this.questionList, { name: ctrl });

            var lower = _.filter(this.questionList, (q) => {
                return q.order > parent.order;
            })

            _.forEach(lower, (l) => {
                for (var property in this.model) {

                    if (l.name === property) {
                        this.model[property] = undefined;
                    }

                }
            })
        }

		public skipDocument() {
			var file = _.find(this.filesToUpload, x => x.name === this.currentUpload);
			file.skipped = true;
			var skippedDocument = {
				displayName: this.currentUpload,
				filename: "N/A (skipped)",
				skipped: true
			};
			this.model.uploadedFiles.push(<any>skippedDocument);
			this.setCurrentUpload();
			
		}
		public canSkip() {
			var file = _.find(this.filesToUpload, x => x.name === this.currentUpload);
			return file && !file.isRequired;
		}
		public unskip(displayName) {
			_.remove(this.model.uploadedFiles, x => x.displayName === displayName);
			var file = _.find(this.filesToUpload, x => x.name === displayName);
			file.skipped = false;
			this.setCurrentUpload();
		}
        public addDocument(document?: Hca.HiLO.ViewModel.IDocumentViewModel, isExtra?: boolean): void {
            if (isExtra) {
                this.extraFileCounter++;
                this.extraDocument.name = this.extraDocument.name + ' ' + this.extraFileCounter;
                this.filesToUpload.push(this.extraDocument);
                this.currentUpload = this.extraDocument.name;

            }

            var config = new Common.DocumentUploadConfig<Hca.HiLO.ViewModel.IDocumentViewModel>();
            config.title = this.currentUpload;
            config.controller = 'app.hilo.controllers.supportingDocumentUploadController';
            config.saveApiRequestConfig = {
                resourceName: 'LegalDocument'
            }
            config.model = document ? _.cloneDeep(document) : null;

            config.onClose = () => {

                if (config.model.filename) {
                    config.model.displayName = this.currentUpload;
                    this.model.uploadedFiles.push(config.model);
                    this.model.id = config.model.id;
                    var file = _.find(this.filesToUpload, ['name', this.currentUpload]);

                    if (file && file !== undefined && file.isAdditional) {
                        _.remove(this.filesToUpload, file);
                        this.setCurrentUpload();

                    } else {

                        file.hasUploaded = true;
                        this.setCurrentUpload();
                    }
                }
                else {
                    // Could be virus or unsupported upload
                    if (isExtra)
                    {
                        var file = _.find(this.filesToUpload, ['name', this.currentUpload]);
                        _.remove(this.filesToUpload, file);
                        this.setCurrentUpload();
                    }
                }
            };
            this.modal.open(config);
        }


        public deleteDocument(id: string) {

            return this.busyPromise = this.api.delete({
                resourceName: 'LegalDocument/Delete',
                params: { id: id }
            }).then(() => {

                var oldFile = _.find(this.model.uploadedFiles, (o) => {
                    return o.id === id;
                });

                if (oldFile.displayName.substring(0, 10) !== 'Additional') {


                    var fileFromList = _.find(this.filesToUpload, ['name', oldFile.displayName]);
                    _.forEach(this.filesToUpload, (file) => {
                        if (file.name === oldFile.displayName) {
                            file.hasUploaded = false;
                            this.currentUpload = file.name;
                            return false;
                        }
                    }
                    );

                    fileFromList.hasUploaded = false;

                    if (this.currentFormName === '') { oldFile.displayName }
                }
                _.pull(this.model.uploadedFiles, oldFile);
            });
        };

        public numberFilesRemaining():number{
            return _.filter(this.filesToUpload, { 'hasUploaded': false,'isRequired':true}).length
        }

		private setCurrentUpload(): void {
            if (this.filesToUpload.length > 0) {
                var remainingFiles = _.filter(this.filesToUpload, {hasUploaded: false, skipped: false});
                if (remainingFiles.length === 0) {
                    this.currentUpload = '';
                }
                else {
                    this.currentUpload = remainingFiles[0].name;
                }
            }
        }

    }
}